export default __webpack_public_path__ + "static/media/chat-icon-bottom-nav-mobile-active.28e55a92.webp";